import React, {useContext} from 'react';
import {useWatch} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import FormattedPrice from '@src/components/FormattedPrice/FormattedPrice';
import useFormValue from '@src/hooks/useFormValue';

export function TotalPriceIndependentField({rowIndex: index, className = 'ms-2'}: {
    rowIndex: number,
    className?: string
}) {
    return <div className={className}>
        <ActualForm rowIndex={index}/>
    </div>;
}

function ActualForm({rowIndex: index}: { rowIndex: number }) {
    const {
        control,
        fieldName,
        modelOptions = {}
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const products = useWatch({control, name: fieldName as 'products'});
    const {currentValue: isFrozen} = useFormValue<IOrderModel>(`${fieldName}.${index}.is_price_frozen`);

    const product = products?.[index];
    if (!product || !product.custom_price && !product.product_id) {
        return <FormattedPrice amount="0"/>;
    }

    if (isFrozen && product.saved_price != null) {
        return <FormattedPrice amount={product.saved_price / 100}/>;
    }

    if (product.custom_price) {
        const price = product.custom_price_type === 'for-unit' ?
                product.custom_price * product.quantity :
                product.custom_price;

        return <FormattedPrice>{price}</FormattedPrice>;
    }

    const price = (modelOptions?.products as any)?.find(
            ({value}: { value: number }) => value === product.product_id
    )?.price;

    return <FormattedPrice>{price == null ? 0 : Math.ceil((price * product.quantity) / 100)}</FormattedPrice>;
}

export function TotalPriceField({rowIndex: index}: IListColumnProps) {
    return <ActualForm rowIndex={index}/>;
}
